import React from "react";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";

const formatBytes = (bytes) => {
  if (!Number.isFinite(bytes)) return "";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

const IncognitoFileChip = ({ file, onRemove }) => {
  if (!file) return null;
  return (
    <Tooltip title={formatBytes(file.size)} placement="top" arrow>
      <Box
        data-testid="incognito-file-chip"
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 0.5,
          maxWidth: 240,
          padding: "4px 8px",
          marginRight: 1,
          backgroundColor: "rgba(255,198,41,0.12)",
          border: "1px solid rgba(255,198,41,0.4)",
          borderRadius: 4,
          color: "#FFC629",
          fontFamily: "Poppins, sans-serif",
          fontSize: "0.8rem",
        }}
      >
        <InsertDriveFileOutlinedIcon fontSize="small" />
        <Typography
          component="span"
          sx={{
            fontFamily: "Poppins, sans-serif",
            fontSize: "0.8rem",
            color: "#FFC629",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            maxWidth: 180,
          }}
        >
          {file.name}
        </Typography>
        <IconButton
          aria-label={`Remove ${file.name}`}
          size="small"
          onClick={onRemove}
          sx={{ color: "#FFC629", padding: "2px" }}
        >
          <CloseRoundedIcon fontSize="inherit" />
        </IconButton>
      </Box>
    </Tooltip>
  );
};

export default IncognitoFileChip;
